import { combineReducers } from 'redux';
import modalReducer from './modal_reducer';
import statusReducer from './status_reducer';


const TyroReducer = combineReducers({
  modal: modalReducer,
  status: statusReducer
});


export default TyroReducer;